const ROLE_IDS = {
  ADMIN: 1,
  LOCATION_MANAGER: 2,
  ENFORCEMENT: 3,
  DASHBOARD: 4,
  CLIENT_DASHBOARD: 5,
  DATA_WIZARD: 6,
  CLIENT_ONLY: 7,
  LOCATION_MANAGER_CLIENT_DASH: 8,
  CDC_CLIENT: 9,
  ACCOUNTANT: 10,
};

export default ROLE_IDS;
